import _ from 'lodash';
import getValidSubmissions from '@/containers/E4ImpactMBA/helpers/getValidSubmissions';

export const getSubmissions = (props: any) => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );

    const baselineMap = _.keyBy(filteredBaseline, 'uoa_id');
    const finalMap = _.keyBy(filteredFinal, 'uoa_id');

    const groupedByUoaId = _.mergeWith(baselineMap, finalMap, (baselineSubmission, finalSubmission) => ({
        baselineSubmission,
        finalSubmission,
    }));

    return Object.values(groupedByUoaId).filter(
        ({baselineSubmission, finalSubmission}: any) => {
            const baselineTotalEmployees = baselineSubmission ? baselineSubmission.jobs_t0_total_number : null;
            const finalTotalEmployees = finalSubmission ? finalSubmission.jobs_t1_total_number : null;

            return finalTotalEmployees > baselineTotalEmployees;
        }
    );
}